export function navigationArrival(performance, fallback) {
  const entry = performance?.getEntriesByType?.('navigation')?.[0]
  if (entry?.responseStart > 0 && Number.isFinite(performance.timeOrigin)) {
    return performance.timeOrigin + entry.responseStart
  }
  const legacy = performance?.timing?.responseStart
  return legacy > 0 ? legacy : fallback
}
